import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { DataGrid } from "@mui/x-data-grid";
import { unwrapResult } from "@reduxjs/toolkit";
import { Select } from "antd";
import Card from "components/Card/Card.js";

import GridItem from "components/Grid/GridItem.js";

import { Breadcrumb, notification } from "antd";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  fetchPlos,
  updatePloPlanning
} from "../../../../reduxToolkit/features/PLO/PLOsSlice";

import moment from "moment";
import ErrorModal from "../../../Components/ErrorModal";
import "./index.css";

import { fetchProgramById } from "reduxToolkit/features/program/ProgramsSlice.js";
import { fetchAcademicYearById } from "../../../../reduxToolkit/features/academicYear/AcademicYearsSlice";
import { fetchSemesterById } from "../../../../reduxToolkit/features/semester/SemestersSlice.js";

const { Option } = Select;

export default function PLO({ match }) {

  const { id } = match.params;
  const { program_id } = match.params;
  const { semesterId } = match.params;

  const { t } = useTranslation();

  const dispatch = useDispatch();

  const [pageSize, setPageSize] = useState(9);
  const [rows, setRows] = useState([]);
  const [selectedYear, setSelectedYear] = useState("");
  const [openSpinner, setOpenSpinner] = useState(true);
  const [openErrorModal, setOpenErrorModal] = useState(false);
  const [handledError, setHandledError] = useState("");
  const [assessmentPrograms, setAssessmentPrograms] = useState([]);

  const semesterStatus = useSelector((state) => state.semester.semesterStatus);
  const semester = useSelector((state) => state.semester.semester);
  const academicYear = useSelector((state) => state.academicYear.academicYear);
  const program = useSelector((state) => state.program.program)
  const AllPlos = useSelector((state) => state.plo.plos);

  useEffect(() => {
    fetchSemester(semesterId);
    fetchAcademicYear(id);
    fetchProgram(program_id);
  }, []);

  useEffect(() => {
    dispatch(fetchPlos(program_id))
        .then(unwrapResult)
        .then((plos) => {
          handleCloseSpinner();
        });
  }, []);

  const handleCloseSpinner = () => {
    setOpenSpinner(false);
  };

  const fetchSemester = async (id) => {
    try {
      const resultAction = await dispatch(fetchSemesterById(id)).unwrap();
    } catch (err) {
      setHandledError(err);
      handleOpenErrorModal();
    }
  };

  const fetchProgram = async (id) => {
    try {
      const resultAction = await dispatch(fetchProgramById(id)).unwrap();
    } catch (err) {
      setHandledError(err);
      handleOpenErrorModal();
    }
  };

  const fetchAcademicYear = async (id) => {
    try {
      const resultAction = await dispatch(fetchAcademicYearById(id)).unwrap();
    } catch (err) {
      setHandledError(err);
      handleOpenErrorModal();
    }
  };

  const handleOpenErrorModal = () => {
    setOpenErrorModal(true);
  };
  const handleCloseErrorModal = () => {
    setOpenErrorModal(false);
  };

  const openNotificationWithIcon = (type, msg) => {
    notification[type]({
      message: type,
      description: msg,
      top: 50,
      duration: 2,
    });
  };

  const onCellEditCommit = async (event) => {
    if (event.value !== null) {
      const value =
        event.field === "target" ||
          event.field === "external_benchmark" ||
          event.field === "internal_benchmark"
          ? event.value
          : moment(event.value).format("YYYY-MM-DD");
      const field = event.field;
      const updated = {
        [field]: value,
      };
      const id = event.id;
      const resultAction = await dispatch(
        updatePloPlanning({ id: id, updated: updated })
      );
      if (updatePloPlanning.fulfilled.match(resultAction)) {
        openNotificationWithIcon("success", `Updated successfully`);
      } else {
        if (resultAction.payload) {
          setHandledError(resultAction.payload);
          handleOpenErrorModal();
        } else {
          setHandledError(resultAction.error);
          handleOpenErrorModal();
        }
      }
    }
  };

  return (
    <div>
      <div>
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={openSpinner}
          onClick={handleCloseSpinner}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>
      <div>
        <GridItem style={{ marginBottom: "5px" }}>
          <Breadcrumb separator=">">
            <Breadcrumb.Item>{t("Planning")}</Breadcrumb.Item>
            <Breadcrumb.Item>{t("Academic Calender")}</Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to={`/citrine/planning/academicCalender/academicYears`}>
                {t("Academic years")}
              </Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link
                to={`/citrine/planning/academicCalender/academicYears/${id}`}
              >
                {t(`${academicYear && academicYear.name}`)}
              </Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>{t("semesters")}</Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link
                to={`/citrine/planning/academicCalender/academicYears/${id}/semesters/${semesterId}`}
              >
                {t(`${semester && semester.name}`)}
              </Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link
                to={`/citrine/planning/academicCalender/academicYears/${id}/semesters/${semesterId}/program/${program_id}`}
              >
                {t(`${program && program.program_degree_name}`)}
              </Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to={`/citrine/planning/programAssessment/PLO`}>
                {t("PLOs Planning ")}
              </Link>
            </Breadcrumb.Item>
          </Breadcrumb>
        </GridItem>
        <Card>
          <div style={{ height: 600, width: "100%" }}>
            <DataGrid
              rows={AllPlos && AllPlos}
              columns={columns}
              onCellEditCommit={onCellEditCommit}
              showCellRightBorder
              pageSize={pageSize}
              onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
              rowsPerPageOptions={[5, 10, 20, 80]}
              pagination
            />
          </div>
        </Card>
        <ErrorModal
          open={openErrorModal}
          handleClose={handleCloseErrorModal}
          handledError={handledError}
        />
      </div>
    </div>
  );
}

const columns = [
  { field: "name", headerName: "PLO", width: 250, sortable: false },
  {
    field: "assessment_start_date",
    headerName: "Assessment Start Date",
    type: "date",
    width: 180,
    editable: true,
    sortable: true,
  },
  {
    field: "assessment_due_date",
    headerName: "Assessment Due Date",
    type: "date",
    width: 180,
    editable: true,
    sortable: true,
  },
  {
    field: "improvement_due_date",
    headerName: "Improvement Due Date",
    type: "date",
    width: 180,
    editable: true,
    sortable: true,
  },
  {
    field: "external_benchmark",
    headerName: "External Benchmark",
    width: 180,
    editable: true,
    sortable: true,
  },
  {
    field: "internal_benchmark",
    headerName: "Internal Benchmark",
    width: 180,
    editable: true,
    sortable: true,
  },

  {
    field: "target",
    headerName: "Target",
    width: 80,
    editable: true,
    sortable: true,
    type: 'number',
  },
];
